import { ComponentType } from '../schematics/components/components-generator';

export type SchematicsFolder = ComponentType;
